import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    user: state.Authentication.user,
    token: state.Authentication.token,
  };
};

export const AuthRoute = ({ children, ...props }) => {
  return (
    <Route
      {...props}
      render={
        ({ location }) =>
          props?.token ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          )
        // (props?.token && JSON.parse(props?.user)?.userRole === 'custodian') ? (
        //     <Redirect
        //         to={{
        //             pathname: '/custodian/home'
        //         }}
        //     />
        // ) : (
        //     <Redirect
        //         to={{
        //             pathname: "/user/home",
        //             state: { from: location },
        //         }}
        //     />
        // )
      }
    />
  );
};

export default connect(mapStateToProps)(AuthRoute);
